export default __webpack_public_path__ + "static/assets/3a296d85c85a5f222663dad932737c86.svg";